import { InteractiveBrowserCredential } from "@azure/identity";
import { BlobServiceClient } from "@azure/storage-blob";

const getPath = (contextId, name) => {
  return `${contextId}${contextId && name && "/"}${name}`;
};

const getBlobContainerClient = () => {
  const credential = new InteractiveBrowserCredential({
    tenantId: window.configs.AUTHORITY.replace(
      "https://login.microsoftonline.com/",
      ""
    ),
    clientId: window.configs.CLIENTID,
    loginStyle: "redirect",
  });

  const blobServiceClient = new BlobServiceClient(
    window.configs.STORAGE_ACCOUNT_ENDPOINT,
    credential
  );

  const containerClient = blobServiceClient.getContainerClient(
    window.configs.STORAGE_CONTAINER
  );
  return containerClient;
};

async function blobToString(blob) {
  const fileReader = new FileReader();
  return new Promise((resolve, reject) => {
    fileReader.onloadend = (ev) => {
      resolve(ev.target.result);
    };
    fileReader.onerror = reject;
    fileReader.readAsText(blob);
  });
}

const BlobStorageService = {
  init: async () => {
    const containerClient = getBlobContainerClient();
    containerClient.exists();
  },

  get: async (contextId, name) => {
    const containerClient = getBlobContainerClient();
    const blobClient = containerClient.getBlobClient(getPath(contextId, name));
    try {
      const downloadBlockBlobResponse = await blobClient.download();
      const downloaded = await blobToString(
        await downloadBlockBlobResponse.blobBody
      );
      return JSON.parse(downloaded);
    } catch (error) {
      // blob does not exist but need to return empty properties anyway
      if (error.statusCode === 404) {
        return [];
      } else {
        throw error;
      }
    }
  },

  save: async (contextId, name, content) => {
    const containerClient = getBlobContainerClient();
    return await containerClient.uploadBlockBlob(
      getPath(contextId, name),
      content,
      content.length
    );
  },

  delete: async (contextId, name) => {
    const containerClient = getBlobContainerClient();
    try {
      return await containerClient.deleteBlob(getPath(contextId, name));
    } catch (error) {
      return error;
    }
  },

  deleteFolder: async (id) => {
    const containerClient = getBlobContainerClient();
    let iter = containerClient.listBlobsFlat({ prefix: id });

    for await (const blob of iter) {
      await containerClient.deleteBlob(blob.name);
    }
  },
};

export default BlobStorageService;
